import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { api, publicAssetUrl } from "../lib/api";
import type { SiteSettings } from "../types";

type BrandResponse = { settings: SiteSettings };

const fallbackSettings: SiteSettings = {
  brand_en: "MarsDrama",
  brand_name: "短剧出海一站式发行",
  logo_url: "/site-assets/logo"
};

export function Brand({ light = false, priority = false }: { light?: boolean; priority?: boolean }) {
  // Keep the first paint stable without seeding the shared public-site cache.
  // HomePage owns the full site query, including the published works list.
  const query = useQuery({ queryKey: ["public-site"], queryFn: () => api<BrandResponse>("/api/public/site"), staleTime: 5 * 60_000, placeholderData: { settings: fallbackSettings } });
  const settings = query.data?.settings || fallbackSettings;
  useEffect(() => {
    if (query.data?.settings) document.title = `${settings.brand_en || "MarsDrama"} ${settings.brand_name || "短剧出海一站式发行"}`;
  }, [query.data?.settings, settings.brand_en, settings.brand_name]);
  return <Link to="/" className={`brand${light ? " brand-light" : ""}`} aria-label={`${settings.brand_en || "MarsDrama"} 首页`}>
    <span className="brand-logo-image"><img src={publicAssetUrl(settings.logo_url || fallbackSettings.logo_url)} alt="" loading="eager" fetchPriority={priority ? "high" : "auto"} decoding="async" width={48} height={48} onError={(event) => { if (event.currentTarget.src.endsWith("/site-assets/logo")) event.currentTarget.src = "/assets/marsdrama-favicon.png"; }} /></span>
    <span><strong>{settings.brand_en || "MarsDrama"}</strong><small>{settings.brand_name || "短剧出海一站式发行"}</small></span>
  </Link>;
}
